import { Export } from '@adgate/common/interfaces/export.interface';
import { Filter } from '@adgate/common/interfaces/filter.interface';
import { QuickSearch } from '@adgate/common/interfaces/quick-search.interface';
import { Tab, TabAccessorInterface } from '@adgate/common/interfaces/tab-accessor.interface';
import { Component, OnInit, ViewChild } from '@angular/core';
import { ProductionRequestGridComponent } from '@adgate/modules/production/components/production-request-grid-component/production-request-grid-component';

@Component({
  selector: 'production-main-component',
  imports: [
    ProductionRequestGridComponent
  ],
  templateUrl: './production-main-component.html',
  styleUrl: './production-main-component.scss',
})
export class ProductionMainComponent extends TabAccessorInterface implements OnInit, QuickSearch, Export, Filter
{
  @ViewChild('tabRequest') tabRequest?: ProductionRequestGridComponent;

  public TAB_REQUEST: number           = 0;

  constructor()
  {
    super();

    this.setActiveTab(this.TAB_REQUEST);
  }

  ngOnInit(): void 
  {
    this.setActiveTab(this.TAB_REQUEST);
  }

  override getTabs(): Tab[] 
  {
    return [
      {tabNum: 0, tabDescription: 'Requests', show: true},
    ];
  }
  
  onRefresh()
  {
    const activeTabComponent = this.getActiveTabComponent();
    activeTabComponent.onRefresh();
  }

  showFilters(): boolean 
  {
    try {
      const activeTabComponent = this.getActiveTabComponent();
      return activeTabComponent?.showFilters() || false;
    } catch {
      return false;
    }        
  }

  onFilter()
  {
    const activeTabComponent = this.getActiveTabComponent();
    activeTabComponent.onFilter();
  }

  getQuickSearchPlaceholder(): string 
  {
    try {
      const activeTabComponent = this.getActiveTabComponent();
      return activeTabComponent?.getQuickSearchPlaceholder() || '';
    } catch {
      return '';
    }    
  }

  onQuickSearch(filter: string | null): void 
  {
    const activeTabComponent = this.getActiveTabComponent();
    activeTabComponent.onQuickSearch(filter);
  }

  onExport()
  {
    const activeTabComponent = this.getActiveTabComponent();
    activeTabComponent.onExport();
  }

  getActiveTabComponent(): any 
  {
    switch (this.getActiveTab()) {
      case this.TAB_REQUEST:
        return this.tabRequest!;
      default:
        throw new Error('Unknown active tab');
    }
  }
}
